(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.collapseThreshold = 0;

      // Early return if header element is not found
      if (!this.header) {
        console.warn('StickyHeader: header element not found');
        return;
      }

      this.setHeaderHeight();
      this.setAnnouncementBarHeight();
      this.setCollapseThreshold();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Observe header size changes so --header-height stays accurate as layout changes
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => {
          // Guard clause: verify header still exists before accessing properties
          if (!this.header) return;
          this.setHeaderHeight();
          this.setAnnouncementBarHeight();
          this.setCollapseThreshold();
        });
        this.resizeObserver.observe(this.header);
        if (this.announcementBar) this.resizeObserver.observe(this.announcementBar);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      const height = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    setAnnouncementBarHeight() {
      const height = this.announcementBar ? this.announcementBar.offsetHeight : 0;
      document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
    }

    setCollapseThreshold() {
      if (!this.header) return;
      // Normalize the header bounds to integer pixels to avoid fractional
      // values causing the collapsed state to flip when the scroll is
      // stopped on exactly the right pixel.
      const boundsBottom = Math.round(Number(this.headerBounds?.bottom || 0));
      this.collapseThreshold = boundsBottom > 0 ? boundsBottom - 2 : this.header.offsetHeight;
    }

    /**
     * Measures the height difference between expanded and collapsed header states.
     * This is used as the hysteresis buffer to prevent flickering.
     * The buffer must be at least as large as the height change to prevent feedback loops.
     */
    measureHeaderHeightDifference() {
      if (!this.header) return 50; // Safe fallback
      
      const isCurrentlyCollapsed = this.header.classList.contains('scrolled-past-header');
      
      // Measure current height
      const currentHeight = this.header.offsetHeight;
      
      // Temporarily toggle state to measure the other height
      if (isCurrentlyCollapsed) {
        this.header.classList.remove('scrolled-past-header');
      } else {
        this.header.classList.add('scrolled-past-header');
      }
      
      // Force layout recalculation
      const otherHeight = this.header.offsetHeight;
      
      // Restore original state
      if (isCurrentlyCollapsed) {
        this.header.classList.add('scrolled-past-header');
      } else {
        this.header.classList.remove('scrolled-past-header');
      }
      
      // Return the absolute difference plus a small margin
      // The +10 provides extra safety margin to ensure we never flicker
      return Math.abs(currentHeight - otherHeight) + 10;
    }

    updateCollapsedState(scrollTop) {
      if (!this.header) return;

      const isCollapsed = this.header.classList.contains('scrolled-past-header');
      const threshold = this.collapseThreshold || 0;
      
      // Calculate hysteresis buffer based on actual header height difference
      // This prevents the feedback loop where collapsing changes page height
      // which then triggers expansion, which triggers collapse, etc.
      // Cache the measurement to avoid repeated DOM thrashing
      if (this._cachedHeightDiff === undefined) {
        this._cachedHeightDiff = this.measureHeaderHeightDifference();
      }
      const buffer = this._cachedHeightDiff;
      
      // Use hysteresis: different thresholds for collapsing vs expanding
      // This creates a "dead zone" where no state change happens, preventing flickering.
      // The buffer must be applied on BOTH transitions to account for the layout shift.
      let shouldCollapse;
      if (isCollapsed) {
        // Already collapsed - only expand if we scroll WELL above the threshold.
        // When we expand, the header gets taller, pushing content down.
        // The scroll position stays the same, but we're now looking at content
        // that was previously higher up. We need enough margin that after
        // expansion, we won't immediately be past the collapse threshold again.
        shouldCollapse = scrollTop >= (threshold - buffer);
      } else {
        // Not collapsed - only collapse if we scroll WELL past the threshold.
        // When we collapse, the header gets shorter, pulling content up.
        // The scroll position stays the same, but we're now looking at content
        // that was previously lower down. We need enough margin that after
        // collapse, we won't immediately be below the expand threshold.
        shouldCollapse = scrollTop >= (threshold + buffer);
      }
      
      if (shouldCollapse === isCollapsed) return;

      // Apply the state change
      if (shouldCollapse) this.header.classList.add('scrolled-past-header');
      else this.header.classList.remove('scrolled-past-header');
      
      this.setHeaderHeight();
      
      // Invalidate cached height diff since layout may have changed
      this._cachedHeightDiff = undefined;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    }

    createObserver() {
      if (!this.header) return;
      const options = { rootMargin: '-1px 0px 0px 0px', threshold: [0, 1] };
      let observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        this.setCollapseThreshold();
        obs.disconnect();
      }, options);
      observer.observe(this.header);
    }

    onScroll() {
      if (!this.header) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      this.updateCollapsedState(scrollTop);

      // Use the computed collapseThreshold here to keep comparisons
      // consistent and prevent borderline pixel values from flipping
      // the header state repeatedly.
      const threshold = this.collapseThreshold;

      if (scrollTop > this.currentScrollTop && scrollTop >= threshold) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop >= threshold) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top + 2) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || !this.header) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeight();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || !this.header) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeight();
    }

    reset() {
      if (this.headerIsAlwaysSticky || !this.header) return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.setHeaderHeight();
    }

    closeMenuDisclosure() {
      if (!this.header) return;
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      if (!this.header) return;
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
